import { queryOptions, useQuery } from "@tanstack/react-query";
import { dashboardApi } from "@/api/dashboard";

export const dashboardKeys = {
  all: ["dashboard"] as const,
  stats: () => [...dashboardKeys.all, "stats"] as const,
  agentStats: () => [...dashboardKeys.all, "agent-stats"] as const,
};

export function statsQueryOptions() {
  return queryOptions({
    queryKey: dashboardKeys.stats(),
    queryFn: () => dashboardApi.getStats(),
    staleTime: 30 * 1000,
  });
}

export function agentStatsQueryOptions() {
  return queryOptions({
    queryKey: dashboardKeys.agentStats(),
    queryFn: () => dashboardApi.getAgentStats(),
    staleTime: 30 * 1000,
  });
}

export function useDashboardStats() {
  return useQuery(statsQueryOptions());
}

export function useAgentDashboardStats() {
  return useQuery(agentStatsQueryOptions());
}
